import React, {useState, useEffect, useRef} from 'react'
import {useQuery} from "react-query"
import useAuth from "auth/useAuth"
import useAreas from "hooks/useAreas"
import moment from 'moment'
import Timeline from "./Timeline"
import TimelineHeader from "./TimelineHeader"
import "./ShiftTimelinePage.css"

export default function ShiftTimeline() {

    const {auth, API} = useAuth()
    const {mountains, defaultArea} = useAreas()
    const [area, setArea] = useState(defaultArea)
    const [startDate, setStartDate] = useState(moment().subtract(14, 'day').format('YYYY-MM-DD'))
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
    const {data, isLoading, refetch} = useQuery(["timeline", area, startDate, endDate], () => auth(API.shiftsTimelineGet, {area: area, start: startDate, end: endDate}).then(response => response.data), {enabled: false})
    const pickerStart = useRef()
    const pickerEnd = useRef()
    
    
    useEffect(() => {
        console.log("DATA", data)
    }, [data])
    
    
	const openStart = () => {
        pickerStart.current.showPicker()
	}

	const openEnd = () => {
        pickerEnd.current.showPicker()
	}

    
    return <div className="container-fluid" id="timeline">
        <section className="white shadow">
            <h3>Pregled smena</h3>
            
            <ul>
                <li>Ovde možeš videti ko je bio u smeni u zadatom periodu</li>
                <li>Može na nekoj određenoj planini, ili na svim planinama zajedno</li>
                <li>Mogle bi da se dodaju i statistike o broju povreda i slično</li>
                <li>Budi strpljiv, može malo da potraje dok ne završi</li>
            </ul>
            
            <div id="timeline-form">
                <select value={area} className="selector" onChange={event => setArea(event.currentTarget.value)}>
                    <option value="">Sve planine</option>
                    {mountains.map(area => <option key={area} value={area}>{area}</option>)}
                </select>
                
                <div className="date-box">
                    <span>od</span>
                    <label className="selector" onClick={openStart}>{moment(startDate).format("dddd, Do MMMM YYYY.")}</label>
                    <input type="date" value={startDate} ref={pickerStart} onChange={event => setStartDate(event.target.value)}/>
                </div>
    
                <div className="date-box">
                    <span>do</span>
                    <label className="selector" onClick={openEnd}>{moment(endDate).format("dddd, Do MMMM YYYY.")}</label>
                    <input type="date" value={endDate} ref={pickerEnd} onChange={event => setEndDate(event.target.value)}/>
                </div>
                
                <button className="btn btn-primary" onClick={refetch}>Prikaži</button>
            </div>
        </section>
        
        {isLoading && <section className="white shadow">
            <div id="spinner"/>
        </section>}
        
        {!!data?.days && <section className="white shadow" id="graph">
            <TimelineHeader days={data.days}/>
            {data.timelines.map(timeline => <Timeline key={timeline.username} timeline={timeline} days={data.days}/>)}
        </section>}
    </div>
    
}